export enum IdentifierNamesGenerator {
    DictionaryIdentifierNamesGenerator = 'dictionary',
    HexadecimalIdentifierNamesGenerator = 'hexadecimal',
    MangledIdentifierNamesGenerator = 'mangled'
}
